export default __webpack_public_path__ + "static/media/bin.a6fd2950.png";